import script from "./FeedBack.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedBack.vue?vue&type=script&setup=true&lang=ts"

import "./FeedBack.vue?vue&type=style&index=0&id=edfb1710&lang=scss"

const __exports__ = script;

export default __exports__